import type { ReactElement, ReactNode } from 'react';
import { cn } from './cn';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  body?: ReactNode;
  /** Usually a single `<Button>`. */
  action?: ReactNode;
  className?: string;
}

export function EmptyState({
  icon,
  title,
  body,
  action,
  className,
}: EmptyStateProps): ReactElement {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 px-6 py-10 text-center',
        className,
      )}
    >
      {icon && (
        <span
          aria-hidden="true"
          className="flex h-11 w-11 items-center justify-center rounded-panel border border-border bg-surface-sunken text-ink-faint"
        >
          {icon}
        </span>
      )}
      <p className="text-sm font-medium text-ink">{title}</p>
      {body && <div className="max-w-sm text-[13px] leading-5 text-ink-muted">{body}</div>}
      {action && <div className="pt-1">{action}</div>}
    </div>
  );
}
